/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-08T15:03:08.637
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listAssignedBill,
	listAssignedBillInit,
	listAssignedBillByAuthorizations,
	deleteAssignedBill
	
} from '@api/storagemanage/AssignedBill';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listAssignedBill({
			state
		}) {
			return new Promise((resolve, reject) => {
				listAssignedBill(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listAssignedBillByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listAssignedBillByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listAssignedBillInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listAssignedBillInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteAssignedBill({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteAssignedBill({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
